import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20photography%20with%20warm%20golden%20amber%20and%20cream%20color%20gradient%2C%20soft%20geometric%20shapes%20floating%20in%20elegant%20composition%2C%20minimalist%20editorial%20style%2C%20luxurious%20texture%2C%20warm%20atmospheric%20lighting%2C%20sophisticated%20background%20with%20subtle%20circular%20elements%2C%20no%20text%2C%20clean%20aesthetic&width=1800&height=800&seq=home-hero-bg&orientation=landscape"
          alt="今日大瓜 - 每日热点瓜事实时更新"
          title="今日大瓜 - 娱乐圈八卦爆料与社会新鲜事一网打尽"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 flex flex-col justify-center h-full w-full px-6 md:px-14">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex -space-x-2">
            <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white/60 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20woman%2C%20minimalist%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=hero-avatar-1&orientation=squarish"
                alt="用户头像"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white/60 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20man%2C%20minimalist%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=hero-avatar-2&orientation=squarish"
                alt="用户头像"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white/60 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20woman%20with%20glasses%2C%20minimalist%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=hero-avatar-3&orientation=squarish"
                alt="用户头像"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <span className="text-white/80 text-sm font-medium">已有 300万+ 瓜友在线围观</span>
        </div>

        <h1 className="text-3xl md:text-6xl font-bold text-white leading-tight max-w-2xl mb-4">
          <span className="font-light">今天又有什么</span>
          <br />
          新鲜瓜料
        </h1>

        <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-md mb-8">
          每日热点瓜事实时更新，娱乐圈八卦爆料与社会新鲜事一网打尽，第一时间为你深度解读吃瓜现场
        </p>

        <div className="flex flex-wrap gap-3">
          <Link
            to="/category/daily-fresh"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-foreground-950 text-sm font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始吃瓜
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/category/deep-dive"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white text-sm font-semibold hover:bg-white/25 transition-colors border border-white/30 whitespace-nowrap cursor-pointer"
          >
            深度解读
          </Link>
        </div>
      </div>
    </section>
  );
}